
<template lang="pug">
	header.sfc-header-no-nav
		b-container(fluid)
			b-row
				b-col()
					a.logo(href="/")
						sfc-logo-blue
				b-col
					.phone
						a(tel="5852865426") (585) 286 - 5426

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	header.sfc-header-no-nav
		>>> .container-fluid
			max-width: 90%
		border-bottom 1px solid sfc-pale-gray
		background #fff
		width 100%
		>>> .logo
			display block
			//height 50px
			margin 16px 0
			max-width: 200px
		>>> .phone
			color sfc-pale-gray
			margin 25px 0
			text-align: right
			a
			a:not([href])
				transition-all()
				text-decoration: none
				cursor: pointer
				color: text-gray
				&:hover
					text-decoration underline
					color: text-gray
</style>

<script>
import SfcLogoBlue from '@/common/components/icons/redesign-v1/sfc-logo-blue'
export default {
	components: {
		SfcLogoBlue
	}
}
</script>










